<button #trigger (click)="openMenu($event)">
    <img src="/assets/images/grid/menuPoint.svg"></button>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="backdrop-selection"
    (backdropClick)="isMenuOpen=false" [cdkConnectedOverlayOpen]="isMenuOpen"
    [cdkConnectedOverlayPositions]="positonArea">
    <div class="overlay-warp">
        <div class="item" (click)="viewRequest($event)">
            <img src="/assets/images/preview-eye.svg">
            <p translate>column.approvals.view</p>
        </div>
    </div>
</ng-template>